import { IconNotFound } from '../Icon/IconNotFound'

interface NotFoundItemType {
  label?: string
  className?: string
}

const NotFoundItem = ({ label, className }: NotFoundItemType) => {
  return (
    <div
      className={`mb-[49px] min-h-[300px] flex flex-col justify-center items-center max-w-[300px] w-[80%] gap-3 text-center mx-auto ${className}`}
    >
      <IconNotFound />
      {label ? <p className='text-dark-500 mt-2 text-mainBody'>{label}</p> : ''}
    </div>
  )
}
export default NotFoundItem
